import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchProducers(organization_id) {
    return RequesterV1.get(
      "organization/partners/query_producers/list_producers/" + organization_id
    );
  },
  downloadRepProducersXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/query_producers/list_producers/${organization_id}/download_rep_producers_xlsx`,
      { responseType: "blob" }
    );
  },
  downloadRepCropFieldsXlsx(organization_id) {
    return RequesterV1.get(
      `organization/partners/query_producers/list_producers/${organization_id}/download_rep_crop_fields_xlsx`,
      { responseType: "blob" }
    );
  }
};
